module.exports = __webpack_public_path__ + "static/media/bahamas.88f0ecba.jpg";